// extracted by mini-css-extract-plugin
export default {"mobile":"style_mobile__7T0KY","live":"style_live__baW5y","edit":"style_edit__0kmcW","laptop":"style_laptop__HbBBQ"};